/*
 * Module for the Insurance edit view
*/
rs.module("content/participant/benefit/insurance/edit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // clear informational messages as the user switches tabs
            $.js(jsSelectors.tabs).find("[data-js=_tab]").click(function () {
                eventBanner.removeAllMessages();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);